import * as React from "react";
const SvgCalendarIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={11} height={10} viewBox="0 0 11 10" {...props}><g fill="none" stroke="#2D3540"><path d="M.5.5h10v9H.5z" /><path strokeLinecap="square" d="M.5 3.5h10" /></g></svg>;
export default SvgCalendarIcon;